module.exports = __webpack_public_path__ + "img/DSC_7030.31c2a831.jpg";